import type { PageType } from '@web/services/Analytics/registry'

// Экран, на котором сейчас пользователь, — контекст для событий v2. Ставится из
// router.afterEach (pageView.ts) и живёт до следующей навигации. Заменяет для v2
// мутабельный pageData: ничего, кроме типа и пути экрана, здесь не копится.
export interface CurrentPage {
  page_type: PageType
  page_path: string
}

let current: CurrentPage = { page_type: 'other', page_path: window.location.pathname }

// Номер захода на экран: растёт, только когда меняется page_path. Смена одного
// query — тот же заход. По нему считается «один раз за экран» у показов v2.
// В CurrentPage не входит: track() раскладывает её в событие целиком.
let visit = 0

export function setCurrentPage (page: CurrentPage): void {
  if (page.page_path !== current.page_path) visit += 1
  current = { ...page }
}

export function getPageVisit (): number {
  return visit
}

export function getCurrentPage (): CurrentPage {
  return { ...current }
}
